<template>
    <!-- PC 버전 -->
    <div v-if="!isMobile" :class="imagePosition === 'left' ? 'flex pl-4' : 'flex justify-between pl-7 pr-5'" class="w-full py-4 bg-white rounded-xl">
        <img v-if="imagePosition === 'left'" class="w-[78px] h-[78px]" :src="avaratUrl" alt="">
        <div class="flex flex-col gap-y-[10px] break-keep px-6" :class="imagePosition === 'left' ? 'pl-6' : 'pr-6'">
            <p class="text-main-1 text-small-size">{{ name }}</p>
            <p class="text-gray_1 text-content-size font-medium">{{ title }}</p>
            <p class="text-text-1 text-small-size" v-html="description"></p>
        </div>
        <img v-if="imagePosition === 'right'" class="w-[78px] h-[78px]" :src="avaratUrl" alt="">
    </div>

    <!-- 모바일 버전 -->
    <div v-else :class="imagePosition === 'left' ? 'flex gap-4' : 'flex gap-4'" class="py-4 pl-3 pr-4 bg-white rounded-2xl">
        <img v-if="imagePosition === 'left'" class="w-[48px] h-[48px]" :src="avaratUrl" alt="">
        <div class="flex flex-col gap-[10px] break-keep">
            <p class="text-small-size-1 text-main-1">{{ name }}</p>
            <p v-if="title" class="font-medium text-gray_1">{{ title }}</p>
            <p v-if="description" class="text-text-1 text-small-size-1 leading-[18px]" v-html="description"></p>
        </div>
        <img v-if="imagePosition === 'right'" class="w-[48px] h-[48px]" :src="avaratUrl" alt="">
    </div>
</template>
<script>
export default {
    name: 'CustomerReviewCard',
    props: {
        avaratUrl: String,
        name: String,
        title: String,
        description: String,
        imagePosition: {
            type: String,
            default: 'left',
            validator: (value) => ['left', 'right'].includes(value)
        },
        isMobile: {
            type: Boolean,
            default: false
        }
    }
}
</script>
